import errorMessages from "../i18n/errorMessages";
import moment from "moment";

const Validation = {
  validator(questions, lang, groups) {
    var isValid = true;

    questions.forEach(x => {
      // Clear error message to prevent duplication
      x.errorMessage = "";
      //alert(x.name);
      if (x.validation === undefined) {
        return;
      }

      //Check to see if question needs to be validated
      //If the group or parent group is hidden, no need to validate
      if (x.group !== undefined) {
        for (let i = 0; i < groups.length; i++) {
          /*  alert(
            "question: " +
              x.name +
              " group: " +
              x.group +
              " and groups name: " +
              groups[i].name +
              " hide: " +
              groups[i].hide
          );   */
          for (let j = 0; j < x.group.length; j++) {
            if (x.group[j] === groups[i].name) {
              if (groups[i].hide === true) {
                //alert("hide: " + groups[i].hide);
                return;
              } else {
                // alert("validate");
                break;
              }
            }
          }
        }
      }

      x.validation.forEach(y => {
        // alert("in validation" + y);
        if (y === "required") {
          if (x.value.length === 0) {
            //  alert(y + " " + x.value.length + " " + x.valid);
            isValid = false;
            x.valid = false;
            x.errorMessage =
              x.errorMessage + this.getErrorMessage("required", lang);
          }
        }

        if (y === "date") {
          if (x.value !== "") {
            if (moment(x.value, "DD-MM-YYYY", true).isValid() === false) {
              isValid = false;
              x.valid = false;
              if (x.errorMessage.length > 0) {
                x.errorMessage = x.errorMessage + " and ";
              }

              x.errorMessage =
                x.errorMessage + this.getErrorMessage("dateFormat", lang);
            } else {
              //alert("in date validation: " + x.value);
              if (x.value !== "") {
                let day = parseInt(x.value.substring(0, 2));
                let month = parseInt(x.value.substring(3, 5));
                let year = parseInt(x.value.substring(6, 10));
                let date = new Date(year, month - 1, day);

                let pastDate = new Date("1900-01-01");
                let todaysDate = new Date();

                // alert("pastDate: " + pastDate + "today: " + todaysDate)
                if (date < pastDate || date > todaysDate) {
                  //alert(y + " " + x.value.length + " " + x.valid);
                  isValid = false;
                  x.valid = false;
                  if (x.errorMessage.length > 0) {
                    x.errorMessage = x.errorMessage + " and ";
                  }

                  x.errorMessage =
                    x.errorMessage + this.getErrorMessage("date", lang);
                }
              }
            }
          }
        }

        if (y === "combinedLength") {
          var totalLength = 0;

          questions.forEach(a => {
            if (a.validation !== undefined) {
              a.validation.forEach(b => {
                if (b === "combinedLength") {
                  totalLength = totalLength + a.value.length;
                }
              });
            }
          });

          if (totalLength > x.maxCombinedLength) {
            //alert(y + " " + x.value.length + " " + x.valid);
            isValid = false;
            x.valid = false;
            if (x.errorMessage.length > 0) {
              x.errorMessage = x.errorMessage + " and ";
            }

            x.errorMessage =
              x.errorMessage + this.getErrorMessage("combinedLength", lang);
          }
        }

        if (y === "email") {
          const pattern = /[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?/;
          if (!pattern.test(x.value)) {
            //  alert(y + " " + x.value.length + " " + x.valid);
            isValid = false;
            x.valid = false;
            if (x.errorMessage.length > 0) {
              x.errorMessage = x.errorMessage + " and ";
            }

            x.errorMessage =
              x.errorMessage + this.getErrorMessage("email", lang);
          }
        }

        if (y === "phone") {
          // alert("phone length: " + x.value.length + " " + x.value);
          if (x.value.includes("_")) {
            isValid = false;
            x.valid = false;

            x.errorMessage =
              x.errorMessage + this.getErrorMessage("phone", lang);
          }
        }

        if (y === "postal") {
          if (x.value.includes("_")) {
            isValid = false;
            x.valid = false;

            x.errorMessage =
              x.errorMessage + this.getErrorMessage("postal", lang);
          }
        }

        // alert(x.valid);
      });
    });

    return isValid;
  },

  getErrorMessage(validationName, language) {
    var message;
    errorMessages.validation_messages.forEach(x => {
      if (x.name === validationName) {
        if (language === "en") {
          message = x.en;
        } else {
          message = x.fr;
        }
      }
    });
    return message;
  }
};

export default Validation;
